module.exports = __webpack_public_path__ + "static/media/FoodTruck_RewardBackground.7b694453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/FoodTruck_RewardBackground.png
// module id = 1359
// module chunks = 3